document.addEventListener("DOMContentLoaded", (loaded) => {
  const itemsLoaderBlock = document.querySelector(".items-loader-grid-block");
  const bannerSlider = document.querySelector(
    ".value-proposition-block"
  );
  const numbersBlock = document.querySelector(".info-numbers-block");
  const archivioNatBlock = document.querySelector(".archivio-naturalistico-block");

  // lazy - dynamic loading
  if (itemsLoaderBlock) {
    import(
      /* webpackChunkName: "itemsLoaderApp" */ "../../blocks/itemsLoaderGridBlock/itemsLoaderGridBlock"
    );
  }
  if (bannerSlider) {
    import(
      /* webpackChunkName: "bannerSliderBlock" */ "../../blocks/bannerSlider/bannerSlider"
    );
  }
  if (numbersBlock) {
    import(
      /* webpackChunkName: "numbersBlock" */ "../../blocks/infoNumbersBlock/infoNumbersBlock"
    );
  }
  if (archivioNatBlock) {
    import(
      /* webpackChunkName: "archivioNat" */ "../../blocks/archivioNaturalistico/archivioNaturalistico"
    );
  }
});
